import '@babel/polyfill';
import ReactSnS from 'bdata-react-sns/dist/sns.bundle';
import _get from 'lodash/get';
import DisplayAds from './ads/displayAds';
import addTicketLinkDelegators from './ticket-link-tracking';
import eventTracking from './tracking/event-tracking';
import getDisableAdSlots from './ads/disableAdSlots';
import { getAdobeTarget } from './adobeGetTarget';
import { initAdsRefresh } from './ads/adsUtils';

const { milbMoment, makeTFL, serverVals = {}, milbLinker } = window;

const { startDate, defaultDate, fallbackDate, view } = serverVals;

const viewsList = {
    scores: 'Scoreboard',
    schedule: 'Schedule'
};

const getStartDate = (startDateParam, defaultDateParam, fallbackDateParam) => {
    return startDateParam || defaultDateParam || fallbackDateParam;
};

const additionalConfig = {
    startDate: getStartDate(startDate, defaultDate, fallbackDate),
    mount: '#scores-schedule-root',
    linker: milbLinker,
    momentTz: milbMoment
};

let config = { ...serverVals, ...additionalConfig };

for (let p in viewsList) {
    if (viewsList.hasOwnProperty(p)) {
        if (view === p) {
            config.initStateConfig[view].startDate = config.startDate;
        } else {
            const { startDate, defaultDate, fallbackDate } = config.initStateConfig[view]; //eslint-disable-line no-shadow
            config.initStateConfig[view].startDate = getStartDate(startDate, defaultDate, fallbackDate);
        }
    }
}

const initSnSApp = () => {
    const SnSApp = new ReactSnS(config);

    SnSApp.prefetch()
        .then(() => {
            SnSApp.render();
        })
        .then(() => {
            eventTracking();
            addTicketLinkDelegators(makeTFL);
            const { disableDesktopAd, disableMobileAd, displayAdConfig } = config;

            /* ad call fired when page first loads */
            const adsDisabled = getDisableAdSlots(disableDesktopAd, disableMobileAd, {
                desktop: ['ad-scores-schedule-top-banner-m', 'ad-scores-schedule-sponsor-m'],
                mobile: ['ad-scores-schedule-top-banner-sm', 'ad-scores-schedule-sponsor-sm']
            });
            DisplayAds.init(displayAdConfig[view], adsDisabled);
            initAdsRefresh(displayAdConfig);
        });
};

const processAdobeTargetContent = {
    displayAdExperience: (adobeTargetContent) => {
        const clonedConfig = { ...config };
        for (let p in viewsList) {
            if (viewsList.hasOwnProperty(p)) {
                clonedConfig.displayAdConfig[p].pageTargeting = Object.assign(
                    {},
                    config.displayAdConfig[p].pageTargeting,
                    { group: `experience${adobeTargetContent.displayAdExperience}` }
                );
            }
        }
        config = clonedConfig;
    },
    sortTemplate: (adobeTargetContent) => {
        config.initStateConfig[view].sortTemplate = adobeTargetContent.sortTemplate;
    }
};

const initAdobeTarget = () => {
    return getAdobeTarget()
        .then((offers) => {
            if (offers.length === 0) {
                return config;
            } else {
                for (let j = 0; j < offers.length; j++) {
                    const adobeTargetContent = _get(offers[j], 'content', []);
                    for (let a = 0; a < adobeTargetContent.length; a++) {
                        let currentOffer = adobeTargetContent[a];
                        for (const property in adobeTargetContent[a]) {
                            if (processAdobeTargetContent[property]) {
                                processAdobeTargetContent[property](currentOffer);
                            }
                        }
                    }
                }

                return config;
            }
        })
        .catch((error) => {
            console.error('error from getAdobeTarget', error);
            return config;
        });
};

// Init targeting, get
initAdobeTarget()
    .then(initSnSApp);
